// extracted by mini-css-extract-plugin
export default {"wrap":"BadRequestPage_wrap__+65tM"};